<!-- START TOPBAR -->
<div class="page-topbar sidebar_shift">
  <!-- START LOGO AREA -->
  <div class="logo-area">
  </div>
  <!-- END LOGO AREA -->
  <!-- START USER MENU -->
  <div class="user-area">

    <div class="pull-right">
      <ul class="info-menu left-lin list-inline list-unstyled">
        <li class="profile showopacity">
          <a href="#" data-toggle="dropdown" class="toggle">
            <img src="/Images/profile-example-2.png" alt="user-image" class="img-circle img-inline">
            <!--<span>{{userName}} <i class="fa fa-angle-down"></i></span>-->
          </a>
          <ul class="dropdown-menu profile">
            <!--<li>
              <a routerLink="change-password">
                <i class="fa fa-key"></i>
                Change password
              </a>
            </li>-->
            <!--<li>
              <a (click)="changeSource()">
                <i class="fa fa-info"></i>
                Change location
              </a>
            </li>-->
            <!--<li>
              <a (click)="getApk()">
                <i class="fa fa-info"></i>
                Install Android app
              </a>
            </li>-->
            <li class="last">
              <a (click)="logout()">
                <i class="fa fa-lock"></i>
                Logout
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <!-- END USER MENU -->
</div>
<!-- END TOPBAR -->
<!-- START CONTAINER -->
<div class="page-container row-fluid container-fluid fixed">

  <!-- SIDEBAR - START -->
  <div class="page-sidebar collapseit">
    <!-- MAIN MENU - START -->
    <div class="page-sidebar-wrapper" id="main-menu-wrapper">
      <ul class="wraplist">
        <li class="menusection">Dashboard</li>
        <li class="">
          <a routerLink="createUser">
            <i class="fa fa-plus-circle"></i>
            <span class="Title">New User</span>
          </a>
        </li>
        <li>
          <a routerLink="users">
            <i class="fa fa-users"></i>
            <span class="Title">Users</span>
          </a>
        </li>
        <li>
          <a routerLink="../manage/result-list">
            <i class="fa fa-line-chart"></i>
            <span class="title">Results Lists</span>
          </a>
        </li>
      </ul>
      <!--<a (click)="logout()" class="list-group-item list-group-item-action">Log out</a>-->
    </div>
    <!-- MAIN MENU - END -->

  </div>
  <!--  SIDEBAR - END -->
    <router-outlet></router-outlet>
</div>

<!-- END CONTAINER -->
